import { css } from 'aphrodite';
import React, { FC } from 'react';
import { style } from './style';

interface Props {
  formRegister: any;
  name: string;
  copy: {
    label: string;
    placeholder: string;
  };
}

export const CommentForm: FC<Props> = ({ formRegister, name, copy }) => {
  const styles = style();

  return (
    <div className={css(styles.commentForm)}>
      <div className={css(styles.headline)}>{copy.label}</div>
      <textarea
        ref={formRegister}
        name={name}
        maxLength={300}
        className={css(styles.commentBox)}
        style={{ resize: 'none' }}
        rows={6}
        placeholder={copy.placeholder}></textarea>
    </div>
  );
};
